/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as TermsRouteImport } from './routes/terms';
import { Route as TechnologyRouteImport } from './routes/technology';
import { Route as PrivacyRouteImport } from './routes/privacy';
import { Route as PricingRouteImport } from './routes/pricing';
import { Route as NotificationsRouteImport } from './routes/notifications';
import { Route as LegalRouteImport } from './routes/legal';
import { Route as IndustriesRouteImport } from './routes/industries';
import { Route as HowBookingsAreAllocatedRouteImport } from './routes/how-bookings-are-allocated';
import { Route as ForTradesRouteImport } from './routes/for-trades';
import { Route as ForPoolCareRouteImport } from './routes/for-pool-care';
import { Route as ForPersonalTrainingRouteImport } from './routes/for-personal-training';
import { Route as ForMortgageBrokersRouteImport } from './routes/for-mortgage-brokers';
import { Route as ForMobileDogGroomingRouteImport } from './routes/for-mobile-dog-grooming';
import { Route as ForMedicalImagingRouteImport } from './routes/for-medical-imaging';
import { Route as ForMechanicsRouteImport } from './routes/for-mechanics';
import { Route as ForGardeningRouteImport } from './routes/for-gardening';
import { Route as ForFinancialPlannersRouteImport } from './routes/for-financial-planners';
import { Route as ForClinicsRouteImport } from './routes/for-clinics';
import { Route as ForAlliedHealthRouteImport } from './routes/for-allied-health';
import { Route as ForAccountantsRouteImport } from './routes/for-accountants';
import { Route as FeaturesRouteImport } from './routes/features';
import { Route as DemosRouteImport } from './routes/demos';
import { Route as ContactRouteImport } from './routes/contact';
import { Route as BuiltForDevelopersRouteImport } from './routes/built-for-developers';
import { Route as AdrsRouteImport } from './routes/adrs';
import { Route as AboutRouteImport } from './routes/about';
import { Route as IndexRouteImport } from './routes/index';
import { Route as AdrsIndexRouteImport } from './routes/adrs.index';
import { Route as AdrsSlugRouteImport } from './routes/adrs.$slug';

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any);
const TechnologyRoute = TechnologyRouteImport.update({
  id: '/technology',
  path: '/technology',
  getParentRoute: () => rootRouteImport,
} as any);
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any);
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any);
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any);
const LegalRoute = LegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any);
const IndustriesRoute = IndustriesRouteImport.update({
  id: '/industries',
  path: '/industries',
  getParentRoute: () => rootRouteImport,
} as any);
const HowBookingsAreAllocatedRoute = HowBookingsAreAllocatedRouteImport.update({
  id: '/how-bookings-are-allocated',
  path: '/how-bookings-are-allocated',
  getParentRoute: () => rootRouteImport,
} as any);
const ForTradesRoute = ForTradesRouteImport.update({
  id: '/for-trades',
  path: '/for-trades',
  getParentRoute: () => rootRouteImport,
} as any);
const ForPoolCareRoute = ForPoolCareRouteImport.update({
  id: '/for-pool-care',
  path: '/for-pool-care',
  getParentRoute: () => rootRouteImport,
} as any);
const ForPersonalTrainingRoute = ForPersonalTrainingRouteImport.update({
  id: '/for-personal-training',
  path: '/for-personal-training',
  getParentRoute: () => rootRouteImport,
} as any);
const ForMortgageBrokersRoute = ForMortgageBrokersRouteImport.update({
  id: '/for-mortgage-brokers',
  path: '/for-mortgage-brokers',
  getParentRoute: () => rootRouteImport,
} as any);
const ForMobileDogGroomingRoute = ForMobileDogGroomingRouteImport.update({
  id: '/for-mobile-dog-grooming',
  path: '/for-mobile-dog-grooming',
  getParentRoute: () => rootRouteImport,
} as any);
const ForMedicalImagingRoute = ForMedicalImagingRouteImport.update({
  id: '/for-medical-imaging',
  path: '/for-medical-imaging',
  getParentRoute: () => rootRouteImport,
} as any);
const ForMechanicsRoute = ForMechanicsRouteImport.update({
  id: '/for-mechanics',
  path: '/for-mechanics',
  getParentRoute: () => rootRouteImport,
} as any);
const ForGardeningRoute = ForGardeningRouteImport.update({
  id: '/for-gardening',
  path: '/for-gardening',
  getParentRoute: () => rootRouteImport,
} as any);
const ForFinancialPlannersRoute = ForFinancialPlannersRouteImport.update({
  id: '/for-financial-planners',
  path: '/for-financial-planners',
  getParentRoute: () => rootRouteImport,
} as any);
const ForClinicsRoute = ForClinicsRouteImport.update({
  id: '/for-clinics',
  path: '/for-clinics',
  getParentRoute: () => rootRouteImport,
} as any);
const ForAlliedHealthRoute = ForAlliedHealthRouteImport.update({
  id: '/for-allied-health',
  path: '/for-allied-health',
  getParentRoute: () => rootRouteImport,
} as any);
const ForAccountantsRoute = ForAccountantsRouteImport.update({
  id: '/for-accountants',
  path: '/for-accountants',
  getParentRoute: () => rootRouteImport,
} as any);
const FeaturesRoute = FeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => rootRouteImport,
} as any);
const DemosRoute = DemosRouteImport.update({
  id: '/demos',
  path: '/demos',
  getParentRoute: () => rootRouteImport,
} as any);
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any);
const BuiltForDevelopersRoute = BuiltForDevelopersRouteImport.update({
  id: '/built-for-developers',
  path: '/built-for-developers',
  getParentRoute: () => rootRouteImport,
} as any);
const AdrsRoute = AdrsRouteImport.update({
  id: '/adrs',
  path: '/adrs',
  getParentRoute: () => rootRouteImport,
} as any);
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const AdrsIndexRoute = AdrsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdrsRoute,
} as any);
const AdrsSlugRoute = AdrsSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => AdrsRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/about': typeof AboutRoute;
  '/adrs': typeof AdrsRouteWithChildren;
  '/built-for-developers': typeof BuiltForDevelopersRoute;
  '/contact': typeof ContactRoute;
  '/demos': typeof DemosRoute;
  '/features': typeof FeaturesRoute;
  '/for-accountants': typeof ForAccountantsRoute;
  '/for-allied-health': typeof ForAlliedHealthRoute;
  '/for-clinics': typeof ForClinicsRoute;
  '/for-financial-planners': typeof ForFinancialPlannersRoute;
  '/for-gardening': typeof ForGardeningRoute;
  '/for-mechanics': typeof ForMechanicsRoute;
  '/for-medical-imaging': typeof ForMedicalImagingRoute;
  '/for-mobile-dog-grooming': typeof ForMobileDogGroomingRoute;
  '/for-mortgage-brokers': typeof ForMortgageBrokersRoute;
  '/for-personal-training': typeof ForPersonalTrainingRoute;
  '/for-pool-care': typeof ForPoolCareRoute;
  '/for-trades': typeof ForTradesRoute;
  '/how-bookings-are-allocated': typeof HowBookingsAreAllocatedRoute;
  '/industries': typeof IndustriesRoute;
  '/legal': typeof LegalRoute;
  '/notifications': typeof NotificationsRoute;
  '/pricing': typeof PricingRoute;
  '/privacy': typeof PrivacyRoute;
  '/technology': typeof TechnologyRoute;
  '/terms': typeof TermsRoute;
  '/adrs/$slug': typeof AdrsSlugRoute;
  '/adrs/': typeof AdrsIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/about': typeof AboutRoute;
  '/built-for-developers': typeof BuiltForDevelopersRoute;
  '/contact': typeof ContactRoute;
  '/demos': typeof DemosRoute;
  '/features': typeof FeaturesRoute;
  '/for-accountants': typeof ForAccountantsRoute;
  '/for-allied-health': typeof ForAlliedHealthRoute;
  '/for-clinics': typeof ForClinicsRoute;
  '/for-financial-planners': typeof ForFinancialPlannersRoute;
  '/for-gardening': typeof ForGardeningRoute;
  '/for-mechanics': typeof ForMechanicsRoute;
  '/for-medical-imaging': typeof ForMedicalImagingRoute;
  '/for-mobile-dog-grooming': typeof ForMobileDogGroomingRoute;
  '/for-mortgage-brokers': typeof ForMortgageBrokersRoute;
  '/for-personal-training': typeof ForPersonalTrainingRoute;
  '/for-pool-care': typeof ForPoolCareRoute;
  '/for-trades': typeof ForTradesRoute;
  '/how-bookings-are-allocated': typeof HowBookingsAreAllocatedRoute;
  '/industries': typeof IndustriesRoute;
  '/legal': typeof LegalRoute;
  '/notifications': typeof NotificationsRoute;
  '/pricing': typeof PricingRoute;
  '/privacy': typeof PrivacyRoute;
  '/technology': typeof TechnologyRoute;
  '/terms': typeof TermsRoute;
  '/adrs/$slug': typeof AdrsSlugRoute;
  '/adrs': typeof AdrsIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/about': typeof AboutRoute;
  '/adrs': typeof AdrsRouteWithChildren;
  '/built-for-developers': typeof BuiltForDevelopersRoute;
  '/contact': typeof ContactRoute;
  '/demos': typeof DemosRoute;
  '/features': typeof FeaturesRoute;
  '/for-accountants': typeof ForAccountantsRoute;
  '/for-allied-health': typeof ForAlliedHealthRoute;
  '/for-clinics': typeof ForClinicsRoute;
  '/for-financial-planners': typeof ForFinancialPlannersRoute;
  '/for-gardening': typeof ForGardeningRoute;
  '/for-mechanics': typeof ForMechanicsRoute;
  '/for-medical-imaging': typeof ForMedicalImagingRoute;
  '/for-mobile-dog-grooming': typeof ForMobileDogGroomingRoute;
  '/for-mortgage-brokers': typeof ForMortgageBrokersRoute;
  '/for-personal-training': typeof ForPersonalTrainingRoute;
  '/for-pool-care': typeof ForPoolCareRoute;
  '/for-trades': typeof ForTradesRoute;
  '/how-bookings-are-allocated': typeof HowBookingsAreAllocatedRoute;
  '/industries': typeof IndustriesRoute;
  '/legal': typeof LegalRoute;
  '/notifications': typeof NotificationsRoute;
  '/pricing': typeof PricingRoute;
  '/privacy': typeof PrivacyRoute;
  '/technology': typeof TechnologyRoute;
  '/terms': typeof TermsRoute;
  '/adrs/$slug': typeof AdrsSlugRoute;
  '/adrs/': typeof AdrsIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/about'
    | '/adrs'
    | '/built-for-developers'
    | '/contact'
    | '/demos'
    | '/features'
    | '/for-accountants'
    | '/for-allied-health'
    | '/for-clinics'
    | '/for-financial-planners'
    | '/for-gardening'
    | '/for-mechanics'
    | '/for-medical-imaging'
    | '/for-mobile-dog-grooming'
    | '/for-mortgage-brokers'
    | '/for-personal-training'
    | '/for-pool-care'
    | '/for-trades'
    | '/how-bookings-are-allocated'
    | '/industries'
    | '/legal'
    | '/notifications'
    | '/pricing'
    | '/privacy'
    | '/technology'
    | '/terms'
    | '/adrs/$slug'
    | '/adrs/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/about'
    | '/built-for-developers'
    | '/contact'
    | '/demos'
    | '/features'
    | '/for-accountants'
    | '/for-allied-health'
    | '/for-clinics'
    | '/for-financial-planners'
    | '/for-gardening'
    | '/for-mechanics'
    | '/for-medical-imaging'
    | '/for-mobile-dog-grooming'
    | '/for-mortgage-brokers'
    | '/for-personal-training'
    | '/for-pool-care'
    | '/for-trades'
    | '/how-bookings-are-allocated'
    | '/industries'
    | '/legal'
    | '/notifications'
    | '/pricing'
    | '/privacy'
    | '/technology'
    | '/terms'
    | '/adrs/$slug'
    | '/adrs';
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/adrs'
    | '/built-for-developers'
    | '/contact'
    | '/demos'
    | '/features'
    | '/for-accountants'
    | '/for-allied-health'
    | '/for-clinics'
    | '/for-financial-planners'
    | '/for-gardening'
    | '/for-mechanics'
    | '/for-medical-imaging'
    | '/for-mobile-dog-grooming'
    | '/for-mortgage-brokers'
    | '/for-personal-training'
    | '/for-pool-care'
    | '/for-trades'
    | '/how-bookings-are-allocated'
    | '/industries'
    | '/legal'
    | '/notifications'
    | '/pricing'
    | '/privacy'
    | '/technology'
    | '/terms'
    | '/adrs/$slug'
    | '/adrs/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AboutRoute: typeof AboutRoute;
  AdrsRoute: typeof AdrsRouteWithChildren;
  BuiltForDevelopersRoute: typeof BuiltForDevelopersRoute;
  ContactRoute: typeof ContactRoute;
  DemosRoute: typeof DemosRoute;
  FeaturesRoute: typeof FeaturesRoute;
  ForAccountantsRoute: typeof ForAccountantsRoute;
  ForAlliedHealthRoute: typeof ForAlliedHealthRoute;
  ForClinicsRoute: typeof ForClinicsRoute;
  ForFinancialPlannersRoute: typeof ForFinancialPlannersRoute;
  ForGardeningRoute: typeof ForGardeningRoute;
  ForMechanicsRoute: typeof ForMechanicsRoute;
  ForMedicalImagingRoute: typeof ForMedicalImagingRoute;
  ForMobileDogGroomingRoute: typeof ForMobileDogGroomingRoute;
  ForMortgageBrokersRoute: typeof ForMortgageBrokersRoute;
  ForPersonalTrainingRoute: typeof ForPersonalTrainingRoute;
  ForPoolCareRoute: typeof ForPoolCareRoute;
  ForTradesRoute: typeof ForTradesRoute;
  HowBookingsAreAllocatedRoute: typeof HowBookingsAreAllocatedRoute;
  IndustriesRoute: typeof IndustriesRoute;
  LegalRoute: typeof LegalRoute;
  NotificationsRoute: typeof NotificationsRoute;
  PricingRoute: typeof PricingRoute;
  PrivacyRoute: typeof PrivacyRoute;
  TechnologyRoute: typeof TechnologyRoute;
  TermsRoute: typeof TermsRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms';
      path: '/terms';
      fullPath: '/terms';
      preLoaderRoute: typeof TermsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/technology': {
      id: '/technology';
      path: '/technology';
      fullPath: '/technology';
      preLoaderRoute: typeof TechnologyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/privacy': {
      id: '/privacy';
      path: '/privacy';
      fullPath: '/privacy';
      preLoaderRoute: typeof PrivacyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/pricing': {
      id: '/pricing';
      path: '/pricing';
      fullPath: '/pricing';
      preLoaderRoute: typeof PricingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/notifications': {
      id: '/notifications';
      path: '/notifications';
      fullPath: '/notifications';
      preLoaderRoute: typeof NotificationsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/legal': {
      id: '/legal';
      path: '/legal';
      fullPath: '/legal';
      preLoaderRoute: typeof LegalRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/industries': {
      id: '/industries';
      path: '/industries';
      fullPath: '/industries';
      preLoaderRoute: typeof IndustriesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/how-bookings-are-allocated': {
      id: '/how-bookings-are-allocated';
      path: '/how-bookings-are-allocated';
      fullPath: '/how-bookings-are-allocated';
      preLoaderRoute: typeof HowBookingsAreAllocatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/for-trades': {
      id: '/for-trades';
      path: '/for-trades';
      fullPath: '/for-trades';
      preLoaderRoute: typeof ForTradesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/for-pool-care': {
      id: '/for-pool-care';
      path: '/for-pool-care';
      fullPath: '/for-pool-care';
      preLoaderRoute: typeof ForPoolCareRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/for-personal-training': {
      id: '/for-personal-training';
      path: '/for-personal-training';
      fullPath: '/for-personal-training';
      preLoaderRoute: typeof ForPersonalTrainingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/for-mortgage-brokers': {
      id: '/for-mortgage-brokers';
      path: '/for-mortgage-brokers';
      fullPath: '/for-mortgage-brokers';
      preLoaderRoute: typeof ForMortgageBrokersRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/for-mobile-dog-grooming': {
      id: '/for-mobile-dog-grooming';
      path: '/for-mobile-dog-grooming';
      fullPath: '/for-mobile-dog-grooming';
      preLoaderRoute: typeof ForMobileDogGroomingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/for-medical-imaging': {
      id: '/for-medical-imaging';
      path: '/for-medical-imaging';
      fullPath: '/for-medical-imaging';
      preLoaderRoute: typeof ForMedicalImagingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/for-mechanics': {
      id: '/for-mechanics';
      path: '/for-mechanics';
      fullPath: '/for-mechanics';
      preLoaderRoute: typeof ForMechanicsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/for-gardening': {
      id: '/for-gardening';
      path: '/for-gardening';
      fullPath: '/for-gardening';
      preLoaderRoute: typeof ForGardeningRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/for-financial-planners': {
      id: '/for-financial-planners';
      path: '/for-financial-planners';
      fullPath: '/for-financial-planners';
      preLoaderRoute: typeof ForFinancialPlannersRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/for-clinics': {
      id: '/for-clinics';
      path: '/for-clinics';
      fullPath: '/for-clinics';
      preLoaderRoute: typeof ForClinicsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/for-allied-health': {
      id: '/for-allied-health';
      path: '/for-allied-health';
      fullPath: '/for-allied-health';
      preLoaderRoute: typeof ForAlliedHealthRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/for-accountants': {
      id: '/for-accountants';
      path: '/for-accountants';
      fullPath: '/for-accountants';
      preLoaderRoute: typeof ForAccountantsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/features': {
      id: '/features';
      path: '/features';
      fullPath: '/features';
      preLoaderRoute: typeof FeaturesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/demos': {
      id: '/demos';
      path: '/demos';
      fullPath: '/demos';
      preLoaderRoute: typeof DemosRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/contact': {
      id: '/contact';
      path: '/contact';
      fullPath: '/contact';
      preLoaderRoute: typeof ContactRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/built-for-developers': {
      id: '/built-for-developers';
      path: '/built-for-developers';
      fullPath: '/built-for-developers';
      preLoaderRoute: typeof BuiltForDevelopersRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/adrs': {
      id: '/adrs';
      path: '/adrs';
      fullPath: '/adrs';
      preLoaderRoute: typeof AdrsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/about': {
      id: '/about';
      path: '/about';
      fullPath: '/about';
      preLoaderRoute: typeof AboutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/adrs/': {
      id: '/adrs/';
      path: '/';
      fullPath: '/adrs/';
      preLoaderRoute: typeof AdrsIndexRouteImport;
      parentRoute: typeof AdrsRoute;
    };
    '/adrs/$slug': {
      id: '/adrs/$slug';
      path: '/$slug';
      fullPath: '/adrs/$slug';
      preLoaderRoute: typeof AdrsSlugRouteImport;
      parentRoute: typeof AdrsRoute;
    };
  }
}

interface AdrsRouteChildren {
  AdrsSlugRoute: typeof AdrsSlugRoute;
  AdrsIndexRoute: typeof AdrsIndexRoute;
}

const AdrsRouteChildren: AdrsRouteChildren = {
  AdrsSlugRoute: AdrsSlugRoute,
  AdrsIndexRoute: AdrsIndexRoute,
};

const AdrsRouteWithChildren = AdrsRoute._addFileChildren(AdrsRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AdrsRoute: AdrsRouteWithChildren,
  BuiltForDevelopersRoute: BuiltForDevelopersRoute,
  ContactRoute: ContactRoute,
  DemosRoute: DemosRoute,
  FeaturesRoute: FeaturesRoute,
  ForAccountantsRoute: ForAccountantsRoute,
  ForAlliedHealthRoute: ForAlliedHealthRoute,
  ForClinicsRoute: ForClinicsRoute,
  ForFinancialPlannersRoute: ForFinancialPlannersRoute,
  ForGardeningRoute: ForGardeningRoute,
  ForMechanicsRoute: ForMechanicsRoute,
  ForMedicalImagingRoute: ForMedicalImagingRoute,
  ForMobileDogGroomingRoute: ForMobileDogGroomingRoute,
  ForMortgageBrokersRoute: ForMortgageBrokersRoute,
  ForPersonalTrainingRoute: ForPersonalTrainingRoute,
  ForPoolCareRoute: ForPoolCareRoute,
  ForTradesRoute: ForTradesRoute,
  HowBookingsAreAllocatedRoute: HowBookingsAreAllocatedRoute,
  IndustriesRoute: IndustriesRoute,
  LegalRoute: LegalRoute,
  NotificationsRoute: NotificationsRoute,
  PricingRoute: PricingRoute,
  PrivacyRoute: PrivacyRoute,
  TechnologyRoute: TechnologyRoute,
  TermsRoute: TermsRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
